import React from 'react';
import { Box } from '@mui/material';
import MedicationIcon from '@mui/icons-material/Medication';

export default function MedChip({ name, color, status, isGroup }) {
    const base = {
        width: '100%',
        fontSize: '9.5px',
        fontWeight: 700,
        letterSpacing: '-0.03em',
        lineHeight: 1.2,
        padding: '1px 3px',
        borderRadius: '4px',
        border: '1px solid transparent',
        boxSizing: 'border-box',
        textAlign: 'left',
        fontVariantNumeric: 'tabular-nums',
    };

    let style;
    if (status === 'asNeeded') {
        style = {
            ...base,
            backgroundColor: '#eff6ff',
            color: '#1d4ed8',
            borderColor: '#60a5fa',
            boxShadow: 'inset 0 0 0 1px #bfdbfe',
        };
    } else if (status === 'taken') {
        style = { ...base, backgroundColor: color.bg, color: color.fg, borderColor: color.bg };
    } else if (status === 'missed') {
        style = {
            ...base,
            backgroundColor: '#fff',
            color: '#b91c1c',
            borderColor: '#ef4444',
            textDecoration: 'line-through',
        };
    } else if (status === 'skipped') {
        style = {
            ...base,
            backgroundColor: '#f5f5f5',
            color: '#9ca3af',
            borderColor: '#e5e7eb',
            textDecoration: 'line-through',
        };
    } else {
        style = { ...base, backgroundColor: '#fff', color: '#999', border: '1px dashed #d4d4d4' };
    }

    if (isGroup) {
        return (
            <Box
                sx={{
                    ...style,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '1px',
                }}
            >
                <Box
                    component="span"
                    sx={{
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {name}
                </Box>
                <MedicationIcon sx={{ fontSize: 10, flexShrink: 0 }} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                ...style,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
        >
            {name}
        </Box>
    );
}
